import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoLabelComponent } from './info-label.component';

@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  declarations: [InfoLabelComponent],
  exports: [
    InfoLabelComponent
  ],
  imports: [
    CommonModule
  ]
})
export class InfoLabelModule { }
